<template>
  <a-card title="通用配置">
    <a-space style="margin-bottom: 12px;">
      <a-select
        style="width:180px;"
        v-model:value="record.is_sandbox"
        :options="[
          {
            label: 'Sandbox 测试环境',
            value: true
          },
          {
            label: '正式环境',
            value: false
          }
        ]"
      />
      <a-button
        type="primary"
        html-type="submit"
        :loading="loading"
        @click="handleConfirm"
      >
        保存
      </a-button>
      <span style="color:red;"> *不点保存不生效，保存后 10 分钟内生效</span>
    </a-space>

    <a-tabs v-model:activeKey="activeTab">
      <a-tab-pane key="common" tab="通用配置">
        <a-form :model="config" style="width: 100%" :label-col="{span:6}" :wrapper-col="{span:18}">
          <a-form-item :label="field" :wrapper-col="{span:18}" v-for="(value, field) in commonConfig" :key="field">
            <a-space>
              <a-input-number v-if="config_typs[field] === 'number'" v-model:value="config[field]" />
              <a-switch v-else-if="config_typs[field] === 'boolean'" v-model:checked="config[field]" />
              <a-textarea :auto-size="{ minRows: 1 }" v-else-if="config_typs[field] === 'string'" v-model:value="config[field]" />
              <a-input v-else :disabled="true" v-model:value="config[field]" />
              <a-tag color="blue">
                {{ config_typs[field] }}
              </a-tag>
              <a-tag color="red" v-if="config_raw[field] !== config[field]">
                changed
              </a-tag>
            </a-space>
          </a-form-item>
          <a-form-item>
            <a-button
              danger
              @click="openDia = true"
            >
              增加
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              :loading="loading"
              @click="handleConfirm"
            >
              保存
            </a-button>
            <span style="color:red;"> *不点保存不生效</span>
          </a-form-item>
        </a-form>
      </a-tab-pane>

      <a-tab-pane key="ab" tab="AB实验">
        <a-alert
          message="AB 实验配置保存到 common_config 的 experiments 字段，支持 Sandbox 和正式环境分别配置。"
          type="info"
          show-icon
          style="margin-bottom: 12px;"
        />
        <a-space style="margin-bottom: 12px;">
          <a-button type="primary" @click="openAddExperimentModal">新增实验</a-button>
          <a-button type="primary" :loading="loading" @click="handleConfirm">保存 AB 实验</a-button>
        </a-space>

        <a-collapse>
          <a-collapse-panel
            v-for="(experiment, experimentIndex) in abExperiments"
            :key="String(experimentIndex)"
            :header="experiment.name || `实验 ${experimentIndex + 1}`"
          >
            <template #extra>
              <a-button danger size="small" @click.stop="handleRemoveExperiment(experimentIndex)">删除实验</a-button>
            </template>

            <a-form :model="experiment" :label-col="{span:3}" :wrapper-col="{span:21}">
              <a-form-item label="ID">
                <a-input-number v-model:value="experiment.id" style="width: 180px;" />
              </a-form-item>
              <a-form-item label="名称">
                <a-input v-model:value="experiment.name" placeholder="实验名称，必须驼峰命名" />
              </a-form-item>
              <a-form-item label="描述">
                <a-input v-model:value="experiment.desc" placeholder="实验描述" />
              </a-form-item>
              <a-form-item label="使用设备ID做实验">
                <a-switch
                  v-model:checked="experiment.use_device_id"
                  checked-children="是"
                  un-checked-children="否"
                />
                <span class="form-item-tip">是否使用设备ID做实验</span>
              </a-form-item>
              <a-form-item v-if="!experiment.use_device_id" label="最小用户ID">
                <a-input-number
                  v-model:value="experiment.min_user_id"
                  :min="0"
                  :controls="false"
                  style="width: 180px;"
                  placeholder="min_user_id"
                />
                <span class="form-item-tip">大于等于该ID的用户才会参与实验</span>
              </a-form-item>
              <a-form-item label="海外用户">
                <a-switch
                  v-model:checked="experiment.is_oversea"
                  checked-children="是"
                  un-checked-children="否"
                />
                <span class="form-item-tip">是否只针对海外用户</span>
              </a-form-item>

              <a-form-item label="Buckets">
                <div class="config-list">
                  <div
                    v-for="(bucket, bucketIndex) in experiment.buckets"
                    :key="bucketIndex"
                    class="config-row"
                  >
                    <a-input v-model:value="bucket.name" placeholder="bucket name" style="width: 180px;" />
                    <a-input-number
                      v-model:value="bucket.percentage"
                      :min="0"
                      :max="100"
                      placeholder="percentage"
                      style="width: 140px;"
                    />
                    <a-input v-model:value="bucket.desc" placeholder="描述" class="flex-input" />
                    <a-button danger @click="handleRemoveBucket(experiment, bucketIndex)">删除</a-button>
                  </div>
                  <a-button type="dashed" @click="handleAddBucket(experiment)">新增 Bucket</a-button>
                </div>
              </a-form-item>

              <a-form-item label="Whitelist">
                <div class="config-list">
                  <div
                    v-for="(item, whitelistIndex) in experiment.whitelistRows"
                    :key="whitelistIndex"
                    class="config-row"
                  >
                    <a-input
                      v-model:value="item.user_id"
                      placeholder="用户 ID"
                      style="width: 180px;"
                    />
                    <a-input v-model:value="item.bucket" placeholder="bucket name" style="width: 220px;" />
                    <a-button danger @click="handleRemoveWhitelist(experiment, whitelistIndex)">删除</a-button>
                  </div>
                  <a-button type="dashed" @click="handleAddWhitelist(experiment)">新增白名单</a-button>
                </div>
              </a-form-item>
            </a-form>
          </a-collapse-panel>
        </a-collapse>
      </a-tab-pane>
    </a-tabs>
  </a-card>

  <a-modal v-model:visible="openDia" :title="'新增配置'" @cancel="resetForm" @ok="handleAddRow" :confirm-loading="loading">
    <a-form>
      <a-form-item>
        <a-space>
          <a-input placeholder="键" v-model:value="record.field" /> :
          <a-input placeholder="值" v-model:value="record.value" />
        </a-space>
      </a-form-item>
      <a-form-item>
        <a-button
          style="visibility: hidden"
          type="primary"
          html-type="submit"
          @click="handleAddRow"
        >
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>

  <a-modal
    v-model:visible="openExperimentDia"
    title="新增实验"
    @cancel="resetExperimentForm"
    @ok="handleAddExperiment"
  >
    <a-form :model="newExperiment" :label-col="{span:5}" :wrapper-col="{span:19}">
      <a-form-item label="ID">
        <a-input-number v-model:value="newExperiment.id" style="width: 180px;" />
      </a-form-item>
      <a-form-item label="名称">
        <a-input v-model:value="newExperiment.name" placeholder="必须驼峰命名" />
      </a-form-item>
      <a-form-item label="描述">
        <a-input v-model:value="newExperiment.desc" placeholder="实验描述" />
      </a-form-item>
      <a-form-item label="使用设备ID做实验">
        <a-switch
          v-model:checked="newExperiment.use_device_id"
          checked-children="是"
          un-checked-children="否"
        />
      </a-form-item>
      <a-form-item v-if="!newExperiment.use_device_id" label="最小用户ID">
        <a-input-number
          v-model:value="newExperiment.min_user_id"
          :min="0"
          :controls="false"
          style="width: 180px;"
          placeholder="min_user_id"
        />
      </a-form-item>
      <a-form-item label="海外用户">
        <a-switch
          v-model:checked="newExperiment.is_oversea"
          checked-children="是"
          un-checked-children="否"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue'
import { message } from 'ant-design-vue'
import request from '@/utils/request'

const clone = (value) => JSON.parse(JSON.stringify(value))

export default defineComponent({
  components: {},
  data() {
    return {
      activeTab: 'common',
      loading: false,
      openDia: false,
      openExperimentDia: false,
      config: {},
      config_typs: {},
      config_raw: {},
      abExperiments: [],
      newExperiment: {
        id: null,
        name: '',
        desc: '',
        use_device_id: false,
        is_oversea: false,
        min_user_id: 0,
      },
      record: {
        is_sandbox: true,
        field: '',
        value: '',
      },
    }
  },
  computed: {
    commonConfig() {
      const result = {}
      for (let key in this.config) {
        if (key !== 'experiments') {
          result[key] = this.config[key]
        }
      }
      return result
    },
  },
  watch: {
    'record.is_sandbox': {
      handler() {
        this.handleTableChange()
      },
      deep: true,
    },
  },
  mounted() {
    this.handleTableChange()
  },
  methods: {
    resetForm() {
      this.record.field = ''
      this.record.value = ''
    },
    resetExperimentForm() {
      this.newExperiment = {
        id: this.getNextExperimentId(),
        name: '',
        desc: '',
        use_device_id: false,
        is_oversea: false,
        min_user_id: 0,
      }
    },
    getNextExperimentId() {
      const ids = this.abExperiments
        .map((experiment) => Number(experiment.id))
        .filter((id) => !Number.isNaN(id))
      return ids.length > 0 ? Math.max(...ids) + 1 : 1
    },
    openAddExperimentModal() {
      this.resetExperimentForm()
      this.openExperimentDia = true
    },
    validateExperimentName(name) {
      return /^[A-Za-z]+$/.test(name || '')
    },
    validateBucketName(name) {
      return /^[A-Za-z0-9]+$/.test(name || '')
    },
    normalizeExperiments(experiments) {
      return experiments.map((experiment) => ({
        id: experiment.id,
        name: experiment.name || '',
        desc: experiment.desc || '',
        use_device_id: Boolean(experiment.use_device_id),
        is_oversea: Boolean(experiment.is_oversea),
        min_user_id: Number(experiment.min_user_id || 0),
        buckets: Array.isArray(experiment.buckets) ? experiment.buckets : [],
        whitelist: experiment.whitelist || {},
        whitelistRows: Object.entries(experiment.whitelist || {}).map(([userId, bucket]) => ({
          user_id: userId,
          bucket,
        })),
        _isNew: false,
      }))
    },
    getExperimentsFromConfig(config) {
      const experimentsConfig = config.experiments
      if (Array.isArray(experimentsConfig)) {
        return this.normalizeExperiments(clone(experimentsConfig))
      }
      if (experimentsConfig && Array.isArray(experimentsConfig.experiments)) {
        return this.normalizeExperiments(clone(experimentsConfig.experiments))
      }
      return []
    },
    buildConfigToSave() {
      let tosave = {
        ...this.config_raw,
      }
      for (let key in this.commonConfig) {
        if (this.config[key] !== this.config_raw[key]) {
          tosave[key] = this.config[key]
          if (this.config_typs[key] === 'number') {
            tosave[key] = Number(this.config[key])
          } else if (this.config_typs[key] === 'boolean') {
            tosave[key] = Boolean(this.config[key])
          }
        }
      }
      tosave.experiments = this.abExperiments.map((experiment) => {
        const whitelist = {}
        for (let item of experiment.whitelistRows || []) {
          if (item.user_id) {
            whitelist[item.user_id] = item.bucket || ''
          }
        }
        return {
          id: experiment.id,
          name: experiment.name || '',
          desc: experiment.desc || '',
          use_device_id: Boolean(experiment.use_device_id),
          is_oversea: Boolean(experiment.is_oversea),
          min_user_id: experiment.use_device_id ? 0 : Number(experiment.min_user_id || 0),
          buckets: Array.isArray(experiment.buckets) ? experiment.buckets : [],
          whitelist,
        }
      })
      return tosave
    },
    validateExperiments() {
      const experimentIds = new Set()
      const experimentNames = new Set()
      for (let experiment of this.abExperiments) {
        const id = String(experiment.id || '')
        const name = experiment.name || ''
        if (id && experimentIds.has(id)) {
          message.warning(`实验 ID ${id} 重复，请修改后再提交`)
          return false
        }
        if (name && experimentNames.has(name)) {
          message.warning(`实验名称 ${name} 重复，请修改后再提交`)
          return false
        }
        if (id) {
          experimentIds.add(id)
        }
        if (name) {
          experimentNames.add(name)
        }

        const totalPercentage = (experiment.buckets || []).reduce((total, bucket) => {
          return total + Number(bucket.percentage || 0)
        }, 0)
        if (totalPercentage !== 100) {
          message.warning(`${experiment.name || '未命名实验'} 的 buckets 流量配比 总和必须等于 100`)
          return false
        }

        if (experiment._isNew) {
          if (!this.validateExperimentName(experiment.name)) {
            message.warning(`${experiment.name || '未命名实验'} 的实验名称只能包含英文字母，不能包含数字或特殊字符，请使用驼峰命名`)
            return false
          }

          for (let bucket of experiment.buckets || []) {
            if (!this.validateBucketName(bucket.name)) {
              message.warning(`${experiment.name || '未命名实验'} 的 bucket name 只能包含英文字母和数字`)
              return false
            }
            if (`${experiment.name || ''}${bucket.name || ''}`.length > 24) {
              message.warning(`${experiment.name || '未命名实验'} 与分桶 ${bucket.name || '未命名分桶'} 名称合计长度不能超过 24 个字符`)
              return false
            }
          }
        }
      }
      return true
    },
    handleConfirm() {
      if (!this.validateExperiments()) {
        return
      }

      this.loading = true
      request.post('/api/sys/common_config', {
        config: this.buildConfigToSave(),
        is_sandbox: this.record.is_sandbox,
      }).then(() => {
        message.success('操作成功')
      }).catch((err) => {
        message.error(err.message)
      }).finally(() => {
        this.loading = false
        this.handleTableChange()
      })
    },
    handleAddRow() {
      if (this.record.field === 'experiments') {
        message.warning('experiments 请在 AB实验 Tab 中维护')
        return
      }
      if (this.record.value == 'true') {
        this.record.value = true
      } else if (this.record.value == 'false') {
        this.record.value = false
      } else if (/^\d+$/.test(this.record.value)) {
        this.record.value = Number(this.record.value)
      }
      this.config[this.record.field] = this.record.value
      this.config_typs[this.record.field] = typeof this.record.value
      this.openDia = false
      this.resetForm()
    },
    handleTableChange() {
      this.loading = true
      request.get('/api/sys/common_config', {
        is_sandbox: this.record.is_sandbox,
      }).then((rsp) => {
        const responseConfig = rsp.data.config || {}
        this.config = {}
        this.config_raw = {}
        this.config_typs = {}
        for (let key in responseConfig) {
          this.config[key] = responseConfig[key]
          this.config_raw[key] = responseConfig[key]
          this.config_typs[key] = typeof responseConfig[key]
        }
        this.abExperiments = this.getExperimentsFromConfig(responseConfig)
        this.config.experiments = this.abExperiments
        this.config_raw.experiments = clone(this.abExperiments)
        this.config_typs.experiments = 'object'
      }).catch((err) => {
        message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    handleAddExperiment() {
      if (!this.newExperiment.name) {
        message.warning('请输入实验名称')
        return
      }
      if (!this.validateExperimentName(this.newExperiment.name)) {
        message.warning('实验名称只能包含英文字母，不能包含数字或特殊字符，请使用驼峰命名')
        return
      }

      this.abExperiments.push({
        id: this.newExperiment.id,
        name: this.newExperiment.name,
        desc: this.newExperiment.desc,
        use_device_id: Boolean(this.newExperiment.use_device_id),
        is_oversea: Boolean(this.newExperiment.is_oversea),
        min_user_id: this.newExperiment.use_device_id ? 0 : Number(this.newExperiment.min_user_id || 0),
        buckets: [],
        whitelist: {},
        whitelistRows: [],
        _isNew: true,
      })
      this.openExperimentDia = false
      this.resetExperimentForm()
    },
    handleRemoveExperiment(index) {
      this.abExperiments.splice(index, 1)
    },
    handleAddBucket(experiment) {
      experiment.buckets.push({
        name: '',
        percentage: 0,
        desc: '',
      })
    },
    handleRemoveBucket(experiment, index) {
      experiment.buckets.splice(index, 1)
    },
    handleAddWhitelist(experiment) {
      if (!Array.isArray(experiment.whitelistRows)) {
        experiment.whitelistRows = []
      }
      experiment.whitelistRows.push({
        user_id: '',
        bucket: '',
      })
    },
    handleRemoveWhitelist(experiment, index) {
      experiment.whitelistRows.splice(index, 1)
    },
  },
  setup() {
    return {}
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.experiment-card {
  margin-bottom: 12px;
}

.config-list {
  width: 100%;
}

.config-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.flex-input {
  flex: 1;
}

.form-item-tip {
  color: #999;
  font-size: 12px;
  margin-left: 8px;
}
</style>
